import type { AtomCommandResult } from "@t3tools/client-runtime/state/runtime";
import type { EnvironmentId, PreviewCloseInput, ScopedThreadRef } from "@t3tools/contracts";

import { beginPreviewSessionClose } from "~/previewStateStore";

interface ClosePreviewSessionInput<E> {
  readonly closePreview: (input: {
    readonly environmentId: EnvironmentId;
    readonly input: PreviewCloseInput;
  }) => Promise<AtomCommandResult<void, E>>;
  readonly tabId: string;
  readonly threadRef: ScopedThreadRef;
}

/**
 * Closes a preview and removes the local session only after the server ACK.
 * Keeping the session mounted while the command is in flight prevents a stale
 * desktop control snapshot from tearing down a remotely controlled guest when
 * the server correctly rejects the close.
 */
export async function closePreviewSession<E>(
  input: ClosePreviewSessionInput<E>,
): Promise<AtomCommandResult<void, E>> {
  const result = await input.closePreview({
    environmentId: input.threadRef.environmentId,
    input: { threadId: input.threadRef.threadId, tabId: input.tabId },
  });
  if (result._tag === "Success") beginPreviewSessionClose(input.threadRef, input.tabId);
  return result;
}
